module.exports = "../images/angling-tips-for-walleye-fishing.jpg?v=b8b0fc9";